import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { getPublicPackage } from '../../reduxStore/actions/packageActionsHelper';
import { publicPackages$, packageLoading$ } from '../../reduxStore/selectors/packageSelectors';
import MenuBar from '../../components/menuBar/menuBar';
import PageFooter from '../../components/pageFooter/pageFooter';
import PricingCard from '../../components/pricingPageComponents/PricingCard/PricingCard';
import PricingLetter from '../../components/pricingPageComponents/PricingLetter/PricingLetter';
import PricingRoadmap from '../../components/pricingPageComponents/PricingRoadmap/PricingRoadmap';
import PricingFAQ from '../../components/pricingPageComponents/PricingFAQ/PricingFAQ';
import PricingHesitant from '../../components/pricingPageComponents/PricingHesitant/PricingHesitant';

const PricingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const packageData = useSelector(publicPackages$);
  const isLoading = useSelector(packageLoading$);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getPublicPackage.request());
  }, [dispatch]);

  const pkg = Array.isArray(packageData) ? packageData[0] : null;
  const price = pkg?.price_vnd ?? 1050000;
  const currency = pkg?.currency_vnd_label ?? 'VND';

  const handleCtaClick = () => navigate('/sign-up');

  return (
    <>
      <Helmet>
        <title>Pricing | Prepal</title>
        <meta name="description" content="One-time founding member pricing for full access to Prepal's AI-powered SAT preparation platform." />
      </Helmet>
      <MenuBar />
      <PricingCard pkg={pkg} isLoading={isLoading} onCtaClick={handleCtaClick} />
      <PricingLetter />
      <PricingRoadmap />
      <PricingFAQ />
      <PricingHesitant price={price} currency={currency} onCtaClick={handleCtaClick} />
      <PageFooter />
    </>
  );
};

export default PricingPage;